"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsibilityFilter = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var filters_1 = require("../editableList/filters");
var multiSelect_1 = require("../lib/multiSelect");
var buttons_1 = require("../buttons");
var queryStringParser_1 = require("../editableList/queryStringParser");
var userdefined_1 = require("../../interfaces/userdefined");
var userDefinedField_1 = require("../userDefinedField");
var config_1 = require("../../config");
var generic_1 = require("../generic");
var riskListToolbar_1 = require("../editableList/riskListToolbar");
var ResponsibilityFilter = (function (_super) {
    __extends(ResponsibilityFilter, _super);
    function ResponsibilityFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.formElement = null;
        _this.count_risk_filters = function () {
            var textNames = ['q'];
            var selectNames = [
                'id_status',
                'id_owner',
                't',
                'confidential',
                'eval'
            ];
            var udf_names = _this.props.filter.udf_types.filter(function (udf_type) {
                return udf_type.target_type_name == 'risk';
            }).map(function (udf_type) {
                return "udf_" + udf_type.id;
            });
            return _this.state.qs.get_key_count_for(textNames.concat(selectNames).concat(udf_names));
        };
        _this.count_control_filters = function () {
            var textNames = ['cq'];
            var selectNames = [
                'id_c_status',
                'id_c_owner',
                'id_c_tags',
                'id_c_costs'
            ];
            var udf_names = _this.props.filter.udf_types.filter(function (udf_type) {
                return udf_type.target_type_name == 'control';
            }).map(function (udf_type) {
                return "udf_" + udf_type.id;
            });
            return _this.state.qs.get_key_count_for(textNames.concat(selectNames).concat(udf_names));
        };
        _this.count_action_filters = function () {
            var textNames = ['aq'];
            var selectNames = [
                'id_ac_status',
                'id_ac_owner',
                'id_ac_tags'
            ];
            return _this.state.qs.get_key_count_for(textNames.concat(selectNames));
        };
        _this.applyHandler = function (event) {
            event.preventDefault();
            event.stopPropagation();
            var paramsString = _this.state.qs.toString();
            window.location.replace(window.location.pathname + "?" + paramsString);
        };
        _this.changeHandler = function (name, value) {
            if (name == "user_id")
                _this.props.filter.selected_users = value;
            var newState = {};
            if ((0, userdefined_1.isFieldType)(name)) {
                value = value.map(function (udf_value) {
                    if (udf_value.field_type.type_id == userDefinedField_1.UDFTypeChoices.DATE &&
                        !udf_value.field_type.options && udf_value.value != null)
                        udf_value.value = udf_value.value.format(config_1.ISO_DATE_FORMAT);
                    return udf_value;
                });
                var udf_type_1 = name;
                newState["udf_values"] = (_this.state.udf_values
                    .filter(function (udf_value) { return udf_value.field_type.id != udf_type_1.id; })
                    .concat(value));
            }
            else
                newState[name] = value;
            var new_qs = _this.state.qs.clone();
            new_qs.reset_from_state(__assign(__assign({}, _this.state), newState));
            newState['qs'] = new_qs;
            _this.setState(newState);
        };
        var qs = new queryStringParser_1.QueryStringParser(window.location.search);
        _this.state = {
            showButton: false,
            qs: qs,
            user_id: qs.getAll("user_id") || [],
            project_group: qs.get("project_group"),
            q: qs.get("q") || "",
            id_status: qs.getAll("id_status"),
            id_owner: qs.getAll("id_owner"),
            t: qs.getAll("t"),
            confidential: qs.getAll("confidential"),
            eval: qs.getAll("eval"),
            reviewed_by: qs.getAll("reviewed_by"),
            reviewed_after: qs.get("reviewed_after"),
            reviewed_before: qs.get("reviewed_before"),
            cq: qs.get("cq") || "",
            id_c_status: qs.getAll("id_c_status"),
            id_c_owner: qs.getAll("id_c_owner"),
            id_c_tags: qs.getAll("id_c_tags"),
            unattached_controls: !!qs.get("unattached_controls"),
            aq: qs.get("aq") || "",
            id_ac_status: qs.getAll("id_ac_status"),
            id_ac_owner: qs.getAll("id_ac_owner"),
            id_ac_tags: qs.getAll("id_ac_tags"),
            udf_values: qs.get_udf_fields(),
        };
        return _this;
    }
    ResponsibilityFilter.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var risk_filter_counter = this.count_risk_filters();
        var control_filter_counter = this.count_control_filters();
        var action_filter_counter = this.count_action_filters();
        var self = this;
        return (React.createElement("div", { className: "ResponsibilityFilter", ref: function (div) {
                var target = $(div);
                target.off('hide.bs.collapse show.bs.collapse');
                target.on('hide.bs.collapse', ".collapse", function () {
                    if (target.find(".collapse.show").length === 1) {
                        self.setState({
                            showButton: false
                        });
                    }
                });
                target.on('show.bs.collapse', ".collapse", function () {
                    if (target.find(".collapse.show").length === 0) {
                        self.setState({
                            showButton: true
                        });
                    }
                });
            } },
            React.createElement("div", { className: "btn-group", role: "group", "aria-label": "Responsibility Toolbar" },
                React.createElement("button", { type: "button", className: "btn btn-link pl-0", "data-toggle": "collapse", "data-target": "#collapseProject", "aria-expanded": "false", "aria-controls": "collapseProject" },
                    React.createElement(generic_1.Icon, { name: generic_1.Icons.filter }),
                    " ",
                    gettext("Project Filter")),
                React.createElement("button", { type: "button", className: "btn btn-link", "data-toggle": "collapse", "data-target": "#collapseRisk", "aria-expanded": "false", "aria-controls": "collapseRisk" },
                    React.createElement(generic_1.Icon, { name: generic_1.Icons.filter }),
                    " ",
                    get_term("Risk Filters"),
                    " ",
                    risk_filter_counter > 0 && (React.createElement("span", { className: "badge badge-pill badge-primary" }, risk_filter_counter))),
                React.createElement("button", { type: "button", className: "btn btn-link", "data-toggle": "collapse", "data-target": "#collapseControl", "aria-expanded": "false", "aria-controls": "collapseControl" },
                    React.createElement(generic_1.Icon, { name: generic_1.Icons.filter }),
                    " ",
                    get_term("Control Filters"),
                    " ",
                    control_filter_counter > 0 && (React.createElement("span", { className: "badge badge-pill badge-primary" }, control_filter_counter))),
                React.createElement("button", { type: "button", className: "btn btn-link", "data-toggle": "collapse", "data-target": "#collapseAction", "aria-expanded": "false", "aria-controls": "collapseAction" },
                    React.createElement(generic_1.Icon, { name: generic_1.Icons.filter }),
                    " ",
                    gettext("Action Filters"),
                    " ",
                    action_filter_counter > 0 && (React.createElement("span", { className: "badge badge-pill badge-primary" }, action_filter_counter))),
                props.addRiskClickHandler &&
                    React.createElement(buttons_1.ActionButton, { id: "add_risk", className: "btn btn-link", onClick: props.addRiskClickHandler },
                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                        " ",
                        get_term("Add risk"))),
            React.createElement("form", { id: "responsibility_list_filter", method: "get", ref: function (me) {
                    if (me && !_this.formElement)
                        _this.formElement = me;
                } },
                React.createElement("div", { className: "row" },
                    React.createElement("div", { className: "col-sm-12 col-md-3 collapse", id: "collapseProject" },
                        props.filter.projects && (React.createElement("div", { id: "responsibility_select_project" },
                            React.createElement("div", { className: "header" },
                                React.createElement("h3", null, gettext("Project")),
                                props.isUpdating &&
                                    React.createElement("div", { className: "iconwrapper" },
                                        React.createElement("i", { className: "fas fa-spinner fa-spin tabSpinner statusTab" }))),
                            React.createElement("select", { id: 'responsibility_project', name: 'project_group', onChange: function (e) {
                                    var group = e.currentTarget.value;
                                    var url = new URL(_this.formElement.action);
                                    url.search = "?project_group=" + group + "&" + riskListToolbar_1.defaultRiskControlActionFilterParams;
                                    window.location.href = url.href;
                                }, className: 'form-control' },
                                React.createElement("optgroup", { label: gettext("Projects") }, props.filter.projects.map(function (project) {
                                    return (React.createElement("option", { selected: props.filter.current_group.toString() == project.value, value: project.value }, project.display_name));
                                })),
                                React.createElement("optgroup", { label: gettext("Project Groups") }, props.filter.project_groups.map(function (project) {
                                    return (React.createElement("option", { selected: props.filter.current_group.toString() == project.value, value: project.value }, project.display_name));
                                }))))),
                        React.createElement("div", { className: "header" },
                            React.createElement("h3", null, gettext("Responsible")),
                            props.isUpdating &&
                                React.createElement("div", { className: "iconwrapper" },
                                    React.createElement("i", { className: "fas fa-spinner fa-spin tabSpinner statusTab" }))),
                        React.createElement("div", { id: 'user_selection' },
                            React.createElement(multiSelect_1.Multiselect, { name: "user_id", choices: props.filter.users, value: props.filter.selected_users, onChangeEvent: function (e) { _this.changeHandler("user_id", e.currentTarget.value); }, classes: "MultiSelect__Button gm--fullwidth", selectedText: '# ' + gettext('owner(s) selected'), noneSelectedText: gettext("Select owners") }))),
                    React.createElement("div", { className: "col-sm-12 col-md-3 collapse", id: "collapseRisk" },
                        React.createElement(filters_1.RiskFilterContent, { status_choices: props.filter.status_choices, users: props.filter.risk_owners, tags: props.filter.tags, confidentiality_groups: props.filter.confidentiality_groups, matrices: props.filter.matrices, risk_reviewers: props.filter.risk_reviewers, include_users: false, isUpdating: this.props.isUpdating, udf_types: props.filter.udf_types, onChange: this.changeHandler, qs: this.state.qs })),
                    React.createElement("div", { className: "col-sm-12 col-md-3 collapse", id: "collapseControl" },
                        React.createElement(filters_1.ControlFilterContent, { control_status_choices: props.filter.control_status_choices, users: props.filter.control_owners, ca_tags: props.filter.control_tags, costs: props.filter.control_costs, include_users: false, include_unattached: false, isUpdating: this.props.isUpdating, udf_types: props.filter.udf_types, onChange: this.changeHandler, qs: this.state.qs })),
                    React.createElement("div", { className: "col-sm-12 col-md-3 collapse", id: "collapseAction" },
                        React.createElement(filters_1.ActionFilterContent, { action_status_choices: props.filter.action_status_choices, users: props.filter.action_owners, ca_tags: props.filter.action_tags, include_users: false, isUpdating: props.isUpdating, onChange: this.changeHandler, qs: this.state.qs }))),
                this.state.showButton && (React.createElement("div", { className: "row mt-1" },
                    React.createElement("div", { className: "col-sm-12 col-md-3" },
                        React.createElement(buttons_1.PrimaryButton, { fullWidth: true, onClick: this.applyHandler }, gettext("Apply"))))))));
    };
    ResponsibilityFilter = __decorate([
        mobx_react_1.observer
    ], ResponsibilityFilter);
    return ResponsibilityFilter;
}(React.Component));
exports.ResponsibilityFilter = ResponsibilityFilter;
